<agpr-take-over-panel
    header="Mention.editDialog.image.selectFromCoverage"
    class="agpr-coverageImageDialog"
    [responsiveWidth]="true"
    [minPanelWidth]="950"
    [maxPanelWidth]="1500"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [overlayContainer]="overlayContainer"
    (visibleChange)="cancel()"
    [focusCloseButton]="true"
>
    <div
        class="agpr-coverageImageDialog-content"
        [agprLoading]="loading"
    >
        <div class="agpr-coverageImageDialog-left">
            <agpr-briefing-source-picker-field
                [id]="'agpr_coverageImageDialog_sourcePicker'"
                class="agpr-newBriefing-quickTemplates-sourcePicker"
                [field]="sourceField"
                [value]="dataSource"
                [showHiddenOption]="true"
            ></agpr-briefing-source-picker-field>
            <div class="agpr-coverageImageDialog-left-actions">
                <agpr-button
                    [id]="'agpr_coverageImageDialog_updateSource'"
                    label="Monitoring.coverageImage.dialog.update"
                    [style]="buttonTypes.tertiary"
                    [disabled]="!totalMentionsCount"
                    (click)="updateSource()"
                ></agpr-button>
            </div>
        </div>
        <div class="agpr-coverageImageDialog-center" role="group">
            @if (!coverageImages?.length) {
                <div class="agpr-coverageImageDialog-center-noContent">
                    <agpr-message
                        [severity]="messageSeverityEnum.noContent"
                        icon="fa-regular fa-file-slash"
                    >
                        {{ 'Monitoring.coverageImage.dialog.noImages' | localize }}
                    </agpr-message>
                </div>
            }
            <cdk-virtual-scroll-viewport
                #viewport
                [itemSize]="230"
                [minBufferPx]="86"
                [maxBufferPx]="172"
                class="virtual-scroll-viewport agpr-virtualScroll"
            >
                <div class="virtual-scroll-container">
                    <div
                        *cdkVirtualFor="let row of rows; let i = index"
                        class="agpr-coverageImageDialog-center-row"
                    >
                        <div
                            *ngFor="let item of row"
                            class="agpr-coverageImageDialog-center-card"
                            [ngClass]="{'agpr-coverageImageDialog-center-card--focused': item.focused}"
                            (click)="focusItem(item)"
                        >
                            <div
                                class="agpr-coverageImageDialog-center-card-left"
                            >
                                <agpr-checkbox
                                    class="agpr-coverageImageDialog-center-card-checkbox"
                                    [value]="item"
                                    [(ngModel)]="item.selected"
                                    [ariaLabel]="'Monitoring.coverageImage.dialog.select' | localize: { name: item.name }"
                                    (ngModelChange)="onCheckboxClick(item)"
                                    (click)="$event.stopPropagation()"
                                    [binary]="true"
                                    [disabled]="maxFileReached && !item.selected"
                                >
                                </agpr-checkbox>
                                @if (item.focused) {
                                    <div class="agpr-coverageImageDialog-center-card-focusedBar"></div>
                                }
                            </div>
                            <div
                                class="agpr-coverageImageDialog-center-card-right"
                            >
                                <div class="agpr-coverageImageDialog-center-card-imageContainer">
                                    @if (item.failed) {
                                        <div class="agpr-coverageImageDialog-imageFailedMessage">
                                            <span class="agpr-imageList-imageFailedIcon fa-regular fa-duotone fa-ban fa-3x"></span>
                                            {{ 'Monitoring.coverageImage.dialog.failed' | localize }}
                                        </div>
                                    } @else {
                                        <img
                                            class="agpr-coverageImageDialog-center-card-image"
                                            [src]="item.url"
                                            [alt]="item.name"
                                            (load)="getImageDimensions($event, item)"
                                            (error)="item.failed = true"
                                        >
                                    }
                                </div>

                                <div class="agpr-coverageImageDialog-center-card-description">
                                    <div
                                        class="agpr-coverageImageDialog-center-card-description-name"
                                        [agprTooltip]="item.name"
                                    >
                                        {{item.name}}
                                    </div>
                                    @if (item.width && item.height) {
                                        <div class="agpr-coverageImageDialog-center-card-description-size">
                                            {{item.width + ' X ' + item.height}}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        @if (row.length === 1) {
                            <div class="agpr-coverageImageDialog-center-cardPlaceholder"></div>
                        }
                    </div>
                </div>
            </cdk-virtual-scroll-viewport>
        </div>

        <div class="agpr-coverageImageDialog-right">
            <agpr-right-sidebar
                #rightSidebar
                class="agpr-coverageImageDialog-rightSidebar"
                [showTabTitle]="false"
                [selectedTabIndex]="selectedTabIndex"
                (selectedTabIndexChange)="tabIndexChange($event)"
            >
                <agpr-tab
                    icon="fa-regular fa-file-lines fa-duotone"
                    tooltip="Common.contentLibrary.details"
                >
                    @if (!focusedItem) {
                        <agpr-message
                            class="agpr-column-right-details-noContent"
                            [severity]="messageSeverityEnum.noContent"
                            icon="fa-regular fa-file-slash"
                        >
                            {{ 'Common.contentLibrary.details.noContent' | localize }}
                        </agpr-message>
                    } @else {
                        <div class="agpr-coverageImageDialog-details">
                            <div
                                class="agpr-coverageImageDialog-details-card"
                            >
                                <div class="agpr-coverageImageDialog-details-card-imageContainer">
                                    @if (focusedItem.failed) {
                                        <div class="agpr-coverageImageDialog-imageFailedMessage">
                                            <span class="agpr-imageList-imageFailedIcon fa-regular fa-duotone fa-ban fa-3x"></span>
                                            {{ 'Monitoring.coverageImage.dialog.failed' | localize }}
                                        </div>
                                    } @else {
                                        <img
                                            class="agpr-coverageImageDialog-center-card-image"
                                            [src]="focusedItem.url"
                                            [alt]="focusedItem.name"
                                        >
                                    }
                                </div>

                                <div class="agpr-coverageImageDialog-center-card-description agpr-coverageImageDialog-details-card-description">
                                    <div
                                        class="agpr-coverageImageDialog-center-card-description-name"
                                        [agprTooltip]="focusedItem.name"
                                    >
                                        {{focusedItem.name}}
                                    </div>
                                    @if (focusedItem.width && focusedItem.height) {
                                        <div class="agpr-coverageImageDialog-center-card-description-size">
                                            {{focusedItem.width + ' X ' + focusedItem.height}}
                                        </div>
                                    }
                                </div>
                            </div>

                            <div class="agpr-coverageImageDialog-details-mention">
                                <div class="agpr-coverageImageDialog-details-mention-label">{{'Common.contentLibrary.details.mention' | localize}}</div>
                                <div class="agpr-coverageImageDialog-details-mention-titleContainer">
                                    <div class="agpr-coverageImageDialog-details-mention-title">
                                        @if (focusedItem.mention.url) {
                                            <a
                                                [href]="focusedItem.mention.url"
                                                target="_blank"
                                                class="agpr-coverageImageDialog-details-mention-link"
                                            >
                                                {{focusedItem.mention.headline}}
                                            </a>
                                        } @else {
                                            {{focusedItem.mention.headline}}
                                        }
                                    </div>
                                    <div class="agpr-coverageImageDialog-details-mention-mediaTypeIcon">
                                        <span
                                            role="img"
                                            class="agpr-mention-mediaTypeIcon"
                                            [ngClass]="focusedItem.mention.mediaType.icon"
                                            [agprTooltip]="focusedItem.mention.mediaType.tooltip"
                                            tooltipPosition="top"
                                        ></span>
                                    </div>
                                </div>
                                @if (focusedItem.mention.publication?.name) {
                                    <div class="agpr-coverageImageDialog-details-mention-outlet">
                                        {{focusedItem.mention.publication.name}}
                                    </div>
                                }
                                @if (focusedItem.mention.author?.name) {
                                    <div class="agpr-coverageImageDialog-details-mention-contact">
                                        {{focusedItem.mention.author?.name}}
                                    </div>
                                }
                                @if (focusedItem.mention.body) {
                                    <div class="agpr-coverageImageDialog-details-mention-body">
                                        {{focusedItem.mention.body}}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    <ng-template #tabFooter>
                        <agpr-action-bar>
                            <ng-template #right>
                            </ng-template>
                        </agpr-action-bar>
                    </ng-template>
                </agpr-tab>
                <agpr-tab
                    icon="fa-regular fa-list-check fa-duotone"
                    tooltip="Common.contentLibrary.selectedFiles"
                >
                    @if (!selectedItems?.length) {
                        <agpr-message
                            class="agpr-column-right-details-noContent"
                            [severity]="messageSeverityEnum.noContent"
                            icon="fa-regular fa-file-slash"
                        >
                            {{ 'Common.contentLibrary.details.noContent' | localize }}
                        </agpr-message>
                    } @else {
                        <div class="agpr-coverageImageDialog-selectedFileContainer">
                        <div class="agpr-coverageImageDialog-selectedFile-header">
                            <span>
                                {{ 'Common.contentLibrary.files.selected' | localize: { count: selectedItems.length } }}
                            </span>
                            <agpr-button
                                class="agpr-coverageImageDialog-selectedFile-header-clear"
                                icon="fa-regular fa-duotone fa-xmark"
                                [agprTooltip]="'Common.contentLibrary.files.selected.clear' | localize"
                                tooltipPosition="left"
                                (click)="clearSelection()"
                            ></agpr-button>
                        </div>

                        <div class="agpr-coverageImageDialog-selectedFile-cardContainer">
                            <div
                                class="agpr-coverageImageDialog-selectedFile-card"
                                *ngFor="let item of selectedItems"
                            >
                                <div class="agpr-coverageImageDialog-selectedFile-card-left">
                                    <img
                                        class="agpr-coverageImageDialog-selectedFile-card-image"
                                        [src]="item.url"
                                        [alt]="item.name"
                                    >
                                </div>
                                <div class="agpr-coverageImageDialog-selectedFile-card-right">
                                    <div
                                        class="agpr-coverageImageDialog-center-card-description-name"
                                        [agprTooltip]="item.name"
                                    >
                                        {{item.name}}
                                    </div>
                                    @if (item.width && item.height) {
                                        <div class="agpr-coverageImageDialog-center-card-description-size">
                                            {{item.width + ' X ' + item.height}}
                                        </div>
                                    }
                                </div>
                                <div class="agpr-coverageImageDialog-selectedFile-card-action">
                                    <agpr-button
                                        agprTooltip="Common.contentLibrary.unselectFile"
                                        tooltipPosition="top"
                                        icon="fa-regular fa-duotone fa-xmark"
                                        (click)="unSelect(item)"
                                    >
                                    </agpr-button>
                                </div>
                            </div>
                        </div>

                        </div>
                    }
                </agpr-tab>
            </agpr-right-sidebar>
        </div>
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="Common.contentLibrary.manageDialog.cancel"
            (click)="cancel()"
            [style]="buttonTypes.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        @if (!!selectedItems?.length) {
            <agpr-button
                label="Common.contentLibrary.manageDialog.select"
                [style]="buttonTypes.primary"
                (click)="onFileSelect()"
            ></agpr-button>
        }
    </ng-template>
</agpr-take-over-panel>